import { useState } from "react";
import "../styles/HomeServices.css";
import { useNavigate } from "react-router-dom";
import servicesarrowicon from "../assets/servicesarrowicon.svg";

import logoIcon from "../assets/Branding/branding-visual-identity-design.svg";
import strategyIcon from "../assets/Branding/branding-social-media-graphs.svg";
import identityIcon from "../assets/Branding/branding-packing-design.svg";
import guidelineIcon from "../assets/Branding/branding-logodesign.svg";
import socialIcon from "../assets/Branding/branding-email-design.svg";
import emailIcon from "../assets/Branding/branding-brandstrategy-positioning.svg";
import pitchIcon from "../assets/Branding/brandinf-brand-guidelins.svg";

import seoIcon from "../assets/Marketing/marketing-seo.svg";
import googleAdsIcon from "../assets/Marketing/marketing-smm.svg";
import metaAdsIcon from "../assets/Marketing/marketing-ppc.svg";
import contentIcon from "../assets/Marketing/marketing-email.svg";
import marketingEmailIcon from "../assets/Marketing/marketing-content-marketing.svg";

import uiIcon from "../assets/Web/web-ui-ux.svg";
import webIcon from "../assets/Web/web-custom-design.svg";
import ecommerceIcon from "../assets/Web/web-e-commerce.svg";
import cmsIcon from "../assets/Web/web-cms.svg";
import maintenanceIcon from "../assets/Web/web-maintenance.svg";
import seoIntegrationIcon from "../assets/Web/web-seo.svg";
import uxIcon from "../assets/Web/web-ui-ux-optimisation.svg";

import appUiIcon from "../assets/Video/video-ui-ux.svg";
import customAppIcon from "../assets/Video/video-custom-app.svg"
import mobileIcon from "../assets/Video/video-mobile.svg";
import appStoreIcon from "../assets/Video/video-app-store.svg";

function HomeServices() {
  const navigate=useNavigate();
  const services = [
    {
      id: 1,
      name: "Branding & Creative Services",
      title: "Branding & Creative Services",

      description:
        "Your brand is much more than just a logo—it's your story, your personality, and the promise you make to your customers. Our Branding & Creative Services help bring your vision to life with bold, memorable, and meaningful designs that reflect who you are. From creating a strong visual identity to building lasting brand recognition, we ensure your business stands out, connects with the right audience, and leaves a lasting impression.",

     tags: [
  {
    title: "Logo Design",
    icon: logoIcon,
  },
  {
    title: "Brand Strategy",
    icon: strategyIcon,
  },
  {
    title: "Visual Identity",
    icon: identityIcon,
  },
  {
    title: "Brand Guidelines",
    icon: guidelineIcon,
  },
  {
    title: "Social Media Graphics",
    icon: socialIcon,
  },
  {
    title: "Email Design",
    icon: emailIcon,
  },
  {
    title: "Pitch Decks",
    icon: pitchIcon,
  },
  // {
  //   title: "Packaging Design",
  //   icon: packageIcon,
  // },
],
    },

    {
      id: 2,
      name: "Marketing",
      title: "Marketing",

      description:
        "The digital world is crowded, but your business doesn't have to get lost in the noise. Our Marketing Services help your brand stand out with smart strategies, engaging campaigns, and data-driven insights. Whether it's improving your Google rankings, running impactful social media ads, or creating content that connects with your audience, we make sure your business reaches the right people at the right time and turn clicks into loyal customers.",

     tags: [
  {
    title: "SEO",
    icon: seoIcon,
  },
  {
    title: "Google Ads",
    icon: googleAdsIcon,
  },
  {
    title: "Meta Ads",
    icon: metaAdsIcon,
  },
  {
    title: "Content Marketing",
    icon: contentIcon,
  },
  {
    title: "Email Marketing",
    icon: marketingEmailIcon,
  },
  // {
  //   title: "Lead Generation",
  //   icon: leadIcon,
  // },
  // {
  //   title: "Marketing Automation",
  //   icon: automationIcon,
  // },
],
    },

    {
      id: 3,
      name: "UI/UX & Web Development",
      title: "UI/UX & Web Development",

      description:
        "Your website is your digital handshake—it's often the first impression people have of your business. Our Web Design & Development services focus on creating fast, responsive, and visually engaging websites that leave a lasting impact. From intuitive user experiences and modern UI design to scalable development and seamless performance, we build digital solutions that not only look exceptional but also drive engagement, build trust, and help your business grow online.",

      tags: [
  {
    title: "UI UX Design",
    icon: uiIcon,
  },
  {
    title: "Custom Web Design",
    icon: webIcon,
  },
  {
    title: "E-Commerce Development",
    icon: ecommerceIcon,
  },
  {
    title: "Content Management Systems (CMS)",
    icon: cmsIcon,
  },
  {
    title: "Website Maintenance & Support",
    icon: maintenanceIcon,
  },
  {
    title: "SEO Integration",
    icon: seoIntegrationIcon,
  },
  {
    title: "UX/UI Optimization",
    icon: uxIcon,
  },
],
    },

//     {
//       id: 4,
//       name: "Video Production",
//       title: "Video Production",

//       description:
//         "Got a brilliant app idea? Let's make it a reality! Whether it's a mobile game, a productivity tool, or the next big social platform, our App Development team creates smooth, intuitive, and engaging apps that people love to use. From concept and design to development and launch, we build high-performance applications with creativity, precision, and a whole lot of coding.",

//       tags: [
//   {
//     title: "UI/UX for Apps",
//     icon: appUiIcon,
//   },
//   {
//     title: "Custom App Development",
//     icon: customAppIcon,
//   },
//   {
//     title: "Mobile Optimization",
//     icon: mobileIcon,
//   },
//   {
//     title: "App Store Optimization",
//     icon: appStoreIcon,
//   },
// ],
//     },
  ];

  const [activeService, setActiveService] = useState(services[0]);

  return (
    <section className="home-services">
      {/* Header */}

      <div className="home-services-header">
        <h2>Our Services</h2>

        <p className="home-services-subtitle">
          We partner with ambitious companies across healthcare,
          technology, software, and emerging ventures.
        </p>
      </div>

      {/* Main Content */}

      <div className="home-services-container">

        {/* Left Menu */}

        <div className="home-services-menu">
          {services.map((service) => (
            <button
              key={service.id}
              className={`home-service-btn ${
                activeService.id === service.id ? "active" : ""
              }`}
              onClick={() => setActiveService(service)}
            >
              {activeService.id === service.id && (
                <img
                  src={servicesarrowicon}
                  alt="Arrow"
                  className="home-service-arrow-img"
                />
              )}

              <span>{service.name}</span>
            </button>
          ))}
        </div>

        {/* Right Content */}

        <div className="home-service-content">
          <h3>{activeService.title}</h3>

          <p>{activeService.description}</p>

          {/* Tags */}

          <div className="home-service-tags">
            {activeService.tags.map((tag, index) => (
  <div key={index} className="home-service-tag">
    <img
      src={tag.icon}
      alt={tag.title}
      className="home-service-tag-icon"
    />

    <span>{tag.title}</span>
  </div>
))}
          </div>

          {/* Button */}

          <button className="home-service-view-btn">
            <span onClick={()=>{navigate("/work")}}>View Details</span>

            <span className="plus-icon">+</span>
          </button>
        </div>
      </div>
    </section>
  );
}

export default HomeServices;